import {OFFER_LISTING_PROMOTION_TAB_LABELS} from "../constants/offer_listing_promotion_tabs";

export interface GetOfferListingAmplitudeItemListNameParams {
    listingTitle: string;
    isPromotionsTab: boolean;
    hasPromotionTabs: boolean;
}

export const getOfferListingAmplitudeItemListName = (
    listingTitle: string,
    options: {isPromotionsTab: boolean; hasPromotionTabs: boolean}
): string | string[] => {
    const normalizedListingTitle = listingTitle.trim();

    if (!options.hasPromotionTabs) {
        return normalizedListingTitle;
    }

    const tabLabel = options.isPromotionsTab ? OFFER_LISTING_PROMOTION_TAB_LABELS.promotions : OFFER_LISTING_PROMOTION_TAB_LABELS.all;

    return normalizedListingTitle ? [tabLabel, normalizedListingTitle] : [tabLabel];
};

export const getOfferListingAmplitudeItemListContext = (params: GetOfferListingAmplitudeItemListNameParams): {itemListName: string | string[]} => ({
    itemListName: getOfferListingAmplitudeItemListName(params.listingTitle, {
        isPromotionsTab: params.isPromotionsTab,
        hasPromotionTabs: params.hasPromotionTabs
    })
});
import {OFFER_LISTING_PROMOTION_TAB_LABELS} from "../constants/offer_listing_promotion_tabs";

export interface GetOfferListingAmplitudeItemListNameParams {
    listingTitle: string;
    isPromotionsTab: boolean;
    hasPromotionTabs: boolean;
}

export const getOfferListingAmplitudeItemListName = (
    listingTitle: string,
    options: {isPromotionsTab: boolean; hasPromotionTabs: boolean}
): string | string[] => {
    const normalizedListingTitle = listingTitle.trim();

    if (!options.hasPromotionTabs) {
        return normalizedListingTitle;
    }

    const tabLabel = options.isPromotionsTab ? OFFER_LISTING_PROMOTION_TAB_LABELS.promotions : OFFER_LISTING_PROMOTION_TAB_LABELS.all;

    return normalizedListingTitle ? [tabLabel, normalizedListingTitle] : [tabLabel];
};

export const getOfferListingAmplitudeItemListContext = (params: GetOfferListingAmplitudeItemListNameParams): {itemListName: string | string[]} => ({
    itemListName: getOfferListingAmplitudeItemListName(params.listingTitle, {
        isPromotionsTab: params.isPromotionsTab,
        hasPromotionTabs: params.hasPromotionTabs
    })
});
